import { IconComponent } from "./components/icon/icon";
import { ToastComponent } from "./components/reusable/toast/toast_component";
import { CompanyComponent } from "./components/simple/company/company";
import { ContactComponent } from "./components/simple/contact/contact";
import { HeroCustom } from "./components/simple/hero/hero";
import { isUnderMaintenace, setMetaData } from "./scripts/utils/utility";

isUnderMaintenace();
const webComponents: Object[] = [
  IconComponent,
  HeroCustom,
  CompanyComponent,
  ContactComponent,
  ToastComponent,
];
webComponents.forEach((item) => item.toString());
setMetaData("home_meta.json");
